import { businessService } from '@/pages/Business/services/business.service';

import type {
  CommerceIntegrationWebhooks,
  IntegrationWebhook,
  IntegrationWebhookCreatePayload,
  IntegrationWebhookDeleteResult,
  IntegrationWebhookUpdatePayload,
} from '../models/IntegrationWebhook';

const integrationWebhooksApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    getCommerceIntegrationWebhooks: builder.query<CommerceIntegrationWebhooks, string>({
      query: (commerceId) => ({ url: '/integration-webhooks', params: { commerceId } }),
      providesTags: ['IntegrationWebhooks'],
    }),

    createIntegrationWebhooks: builder.mutation<IntegrationWebhook[], IntegrationWebhookCreatePayload>({
      query: (body) => ({ url: '/integration-webhooks', method: 'POST', body }),
      invalidatesTags: ['IntegrationWebhooks'],
    }),

    updateIntegrationWebhook: builder.mutation<
      IntegrationWebhook,
      { webhookId: string; payload: IntegrationWebhookUpdatePayload }
    >({
      query: ({ webhookId, payload }) => ({
        url: `/integration-webhooks/${webhookId}`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['IntegrationWebhooks'],
    }),

    deleteIntegrationWebhook: builder.mutation<IntegrationWebhookDeleteResult, string>({
      query: (webhookId) => ({ url: `/integration-webhooks/${webhookId}`, method: 'DELETE' }),
      invalidatesTags: ['IntegrationWebhooks'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCommerceIntegrationWebhooksQuery,
  useCreateIntegrationWebhooksMutation,
  useUpdateIntegrationWebhookMutation,
  useDeleteIntegrationWebhookMutation,
} = integrationWebhooksApi;
